export default {
  template: '#premium_widget_template',
};